import { API } from 'aws-amplify';

import { listLeads } from '../graphql/queries';
import { updateLead } from '../graphql/mutations';

// Find any pending Leads (status != converted) that match the given email or phone,
// and flip them to converted. Called from the tenant signup flow.
export async function markMatchingLeadsConverted(opts: {
  email?: string | null;
  phone?: string | null;
}): Promise<void> {
  const email = opts.email?.trim() || null;
  const phone = opts.phone?.trim() || null;
  if (!email && !phone) return;

  const ors: any[] = [];
  if (email) ors.push({ email: { eq: email } });
  if (phone) ors.push({ phone: { eq: phone } });

  const filter = {
    and: [
      { or: ors },
      { status: { ne: 'converted' } },
    ],
  };

  try {
    const res: any = await API.graphql({
      query: listLeads,
      variables: { filter, limit: 50 },
    });
    const items: Array<{ id: string }> = res?.data?.listLeads?.items ?? [];
    if (items.length === 0) return;

    await Promise.all(items.map(item =>
      API.graphql({
        query: updateLead,
        variables: { input: { id: item.id, status: 'converted' } },
      }).catch(err => console.warn(`[leadAutoConvert] failed to update ${item.id}:`, err))
    ));
  } catch (err) {
    console.warn('[leadAutoConvert] lookup failed:', err);
  }
}
